import * as React from "react";
import { useCallback, useMemo } from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { useRenderProjectsShowing } from "hooks/useRenderProjectsShowing";
import { ProductListTable } from "./SubComponents/ProductListTable";
import { TablePagination } from "../TablePagination";

export const ProductListOfProject = Scrivito.connect(
  ({
    currentPageNo,
    fetchingProductList,
    commissionFetching,
    isOrderDescending,
    pagesCount,
    products,
    productsCount,
    setCurrentPageNo,
    setIsOrderDescending,
    tableRef,
    commissioningProduct,
    itemsPerPage,
    setSortCriteria,
    sortCriteria,
    isModalView,
    priceGroupDescription,
  }) => {
    const renderProjectsShowing = useRenderProjectsShowing();
    const skeletonCount = useMemo(() => {
      if (productsCount === 0) {
        return 10;
      }
      return +currentPageNo !== +pagesCount
        ? itemsPerPage
        : productsCount - itemsPerPage * (currentPageNo - 1);
    }, [currentPageNo, pagesCount, productsCount, itemsPerPage]);

    const isLastPage = useMemo(
      () => currentPageNo === pagesCount,
      [currentPageNo, pagesCount],
    );

    const handleSetCurrentPage = useCallback(
      (pageToSet) => {
        setCurrentPageNo(
          pageToSet > pagesCount ? pageToSet - 1 : pageToSet || 1,
        );
      },
      [setCurrentPageNo, pagesCount],
    );

    return (
      <>
        <div
          className={cx("w-100 m-0 d-flex row pb-0 overflow-auto")}
          style={
            isModalView
              ? { maxHeight: "calc(70vh - 8rem)" }
              : { maxHeight: "650px" }
          }
        >
          <ProductListTable
            products={products}
            isOrderDescending={isOrderDescending}
            setIsOrderDescending={setIsOrderDescending}
            skeletonCount={skeletonCount}
            fetchingProductList={fetchingProductList}
            commissionFetching={commissionFetching}
            tableRef={tableRef}
            isLastPage={isLastPage}
            commissioningProduct={commissioningProduct}
            setSortCriteria={setSortCriteria}
            sortCriteria={sortCriteria}
            setCurrentPageNo={setCurrentPageNo}
            isModalView={isModalView}
            priceGroupDescription={priceGroupDescription}
          />
        </div>
        <div className="position-relative d-flex justify-content-center w-100 pt-1_5 pb-2_5 text-gray-700">
          <div className="position-absolute top-0 start-0 text-gray-400">
            {renderProjectsShowing(currentPageNo, productsCount, itemsPerPage)}
          </div>
          <TablePagination
            pagesCount={pagesCount}
            currentPage={currentPageNo}
            onChangePage={handleSetCurrentPage}
          />
        </div>
      </>
    );
  },
);
